export default __webpack_public_path__ + "static/QuizBg-572661ccbd50fddfc68ab0989a5433bb.png";